import { type FC } from "react";
import { twMerge } from "tailwind-merge";

import { t } from "i18n/i18n";
import { SquareButton } from "mds/components/buttons/SquareButton";

type SubmitOrCancelButtonsProps = {
  // Note: `onSubmit` is intentionally *not* included here.
  // This component is meant to be used inside a <form> element, and the form should handle submission.
  // If you think you need an `onSubmit` prop here, please put it on the <form> element instead.
  className?: string;
  disableSubmit?: boolean;
  submitText?: string;
  submitEventName?: string;
  cancelText?: string;
  cancelEventName?: string;
  onCancel?: () => void;
};

export const SubmitOrCancelButtons: FC<SubmitOrCancelButtonsProps> = ({
  className,
  disableSubmit = false,
  submitText = t("common.save_changes"),
  submitEventName,
  cancelText = t("common.cancel"),
  cancelEventName,
  onCancel,
}) => {
  return (
    // Note that we use `flex-row-reverse` here to make the primary button appear on the right.
    // This is for accessibility reasons, as screen readers will read the buttons in DOM order:
    // first the "Save changes" button, then the "Cancel" button.
    <div className={twMerge("flex flex-row-reverse justify-start gap-2", className)}>
      <SquareButton
        disabled={disableSubmit}
        eventName={submitEventName}
        kind="accent"
        size="m"
        title={submitText}
        type="submit"
      >
        {submitText}
      </SquareButton>

      <SquareButton
        eventName={cancelEventName}
        kind="tertiary"
        size="m"
        title={cancelText}
        onClick={onCancel}
      >
        {cancelText}
      </SquareButton>
    </div>
  );
};
